<template>
    <div class="page-content">
        <h2 class="title mb-2 mb-md-0">Invoice Registries</h2>
        <div class="d-none d-md-flex flex-md-row align-items-center float-end mb-3">
            <!-- Search -->
            <div class="top_heading_CreatePartner_btn position-relative z-index-999 mx-2 ">
                <div class="Group_top_three_dot">
                    <div class="Searching_input-box open">
                        <input type="text" v-model="searchInput" placeholder="Search Company/Client ID..."
                            @keyup.enter="searchInvoices" />
                        <span class="icon Group_top_three_dot_dropdown" @click="opensearch">
                            <img src="../../../public/dashboard-assets/images/M2/Icon-Set.png" alt=""
                                class="Searching_search_icon" />
                        </span>
                        <img src="../../../public/dashboard-assets/images/M2/Close_icon.png" @click="closesearch" alt=""
                            class="close-icon" />
                    </div>
                </div>
            </div>

            <!-- Add Button -->
            <div class="top_heading_CreatePartner_btn">
                <button class="btn btn-primary fw-bold d-flex align-items-center px-4 py-2" type="button"
                    data-bs-toggle="modal" :data-bs-target="`#addInvoice`">
                    <i class="fa-solid fa-plus me-1"></i> <span class="fs-5">Add</span>
                </button>
            </div>
        </div>

        <div class="mt-5 mb-5">
            <div class="col-xl-7 col-lg-7 partners_top_menu_section_hp mb-n4">
                <div class="row">
                    <div class="col-6">
                        <button class="w-100 btn btn-outline-primary fs-bolder"
                            :class="{ active: activeTab === 'active' }" @click="activeTab = 'active'">
                            Active
                        </button>
                    </div>
                    <div class="col-6">
                        <button class="w-100 btn btn-outline-primary" :class="{ active: activeTab === 'inactive' }"
                            @click="activeTab = 'inactive'">
                            Inactive
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Mobile View Search and Add -->
        <div class="d-flex d-md-none align-items-center justify-content-between mb-3">
            <!-- Mobile Search Button -->
            <div class="mobile-search-container">
                <div class="search-icon" @click="toggleMobileSearch" v-if="!showMobileSearch">
                    <img src="../../../public/dashboard-assets/images/M2/Icon-Set.png" alt="search" />
                </div>
                <!-- Mobile Search Input -->
                <div class="mobile-search-input" v-if="showMobileSearch">
                    <input type="text" v-model="searchInput" placeholder="Search..." @keyup.enter="fetchInvoices" />
                    <img src="../../../public/dashboard-assets/images/M2/Close_icon.png" @click="closeMobileSearch"
                        alt="close" class="mobile-close-icon" />
                </div>
            </div>

            <!-- Mobile Add Button -->
            <div class="mobile-add-btn">
                <button class="btn btn-primary" type="button" data-bs-toggle="modal" :data-bs-target="`#addInvoice`">
                    Add
                </button>
            </div>
        </div>

        <!-- Invoice table -->
        <div class="table-responsive card p-2" style="width: 100%; max-height: 500px;" v-if="invoices.length > 0">
            <table class="table">
                <thead>
                    <tr>
                        <th>Company</th>
                        <th>Invoice No</th>
                        <th>Client ID</th>
                        <th>Test ID</th>
                        <th>Region ID</th>
                        <th>User ID</th>
                        <th>Action</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="invoice in invoices" :key="invoice.id">
                        <td>{{ invoice.company }}</td>
                        <td>{{ invoice.invoiceNumber }}</td>
                        <td>{{ invoice.clientId }}</td>
                        <td>{{ invoice.testId }}</td>
                        <td>{{ invoice.regionId }}</td>
                        <td>{{ invoice.userId }}</td>
                        <td>
                            <!-- three dot button  -->
                            <div class="action-buttons ms-2">

                                <button class="btn p-0 Group_top_three_dot_dropdown" type="button"
                                    data-bs-toggle="modal" :data-bs-target="'#editInvoiceModal-' + invoice.id"
                                    @click="loadTempInvoice(invoice)">
                                    <i class="fa-solid fa-ellipsis"></i>
                                </button>



                            </div>
                            <!-- Modal for Adding Invoice -->
                            <div class="modal fade" :id="`addInvoice`" tabindex="-1" aria-hidden="true">
                                <div class="modal-dialog modal-dialog-centered">
                                    <div class="modal-content">
                                        <div class="modal-body">
                                            <form @submit.prevent="AddInvoice">
                                                <h5 class="mb-4">
                                                    Add Invoice
                                                    <button type="button" class="btn-close float-end"
                                                        data-bs-dismiss="modal" @click="clearInputs()"></button>
                                                </h5>

                                                <!-- select dropdown for partners -->
                                                <label class="input-hero w-100">
                                                    <span class="input-name">
                                                        Company
                                                    </span>
                                                    <vue3-select style="width: 100%;" v-model="selectedPartner"
                                                        :options="clientsList" label="label"
                                                        placeholder="Select an option"
                                                        @update:modelValue="updateClientId()" required class="mb-3" />
                                                </label>

                                                <label class="input-hero w-100">
                                                    <span class="input-name">
                                                        Invoice No.
                                                    </span>
                                                    <input type="text" v-model="invoiceNumber" class="form-control mb-3"
                                                        required @input="validateInvoiceNo">
                                                    <span v-if="invoiceError" class="text-danger">{{ invoiceError
                                                        }}<br></span>
                                                </label>

                                                <label class="input-hero w-100">
                                                    <span class="input-name">
                                                        Client ID
                                                    </span>
                                                    <input type="number" v-model="selectedClientId" class="form-control mb-3"
                                                        disabled>
                                                </label>

                                                <label class="input-hero w-100">
                                                    <span class="input-name">
                                                        Test ID
                                                    </span>
                                                    <input type="text" v-model="testId" class="form-control mb-3" required
                                                        @input="validateTestId">
                                                    <span v-if="testError" class="text-danger">{{ testError
                                                    }}</span><br></label>

                                                <label class="input-hero w-100">
                                                    <span class="input-name">
                                                        Region ID
                                                    </span>
                                                    <input type="text" v-model="this.regionId" class="form-control mb-3"
                                                        required @input="validateRegionId">
                                                    <span v-if="regionError" class="text-danger">{{ regionError
                                                    }}</span><br></label>

                                                <label class="input-hero w-100">
                                                    <span class="input-name">
                                                        User ID
                                                    </span>
                                                    <vue3-select style="width: 100%;" v-model="this.selectedUserId"
                                                        :options="this.Ids" label="label" placeholder="Select an option"
                                                        class="mb-3" required /></label>

                                                <label class="input-hero w-100">
                                                    <span class="input-name">
                                                        Billing Email
                                                    </span>
                                                    <input type="text" v-model="this.billingEmail" class="form-control mb-3"
                                                        disabled></label>

                                                <div class="text-end mt-4">
                                                    <button type="button" class="btn me-2" :class="'secondary-button'"
                                                        data-bs-dismiss="modal" @click="clearInputs()">
                                                        Cancel
                                                    </button>
                                                    <button type="submit" class="btn btn-primary">
                                                        Add
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Modal for Editing Invoice -->
                            <div class="modal fade" :id="'editInvoiceModal-' + invoice.id" tabindex="-1"
                                aria-hidden="true">
                                <div class="modal-dialog modal-dialog-centered">
                                    <div class="modal-content">
                                        <div class="modal-body">
                                            <form @submit.prevent="updateInvoice(invoice)">
                                                <h5 class="mb-4">
                                                    Edit Invoice
                                                    <button type="button" class="btn-close float-end"
                                                        data-bs-dismiss="modal" @click="resetTempInvoice()"></button>
                                                </h5>

                                                <label class="input-hero w-100">
                                                    <span class="input-name">
                                                        Invoice No.
                                                    </span>
                                                    <input type="text" v-model="tempInvoice.invoiceNumber"
                                                        class="form-control mb-3" @input="validateUpdateInvoiceNo()">
                                                    <span v-if="updateInvoiceError" class="text-danger">{{
                                                        updateInvoiceError
                                                    }}<br></span></label>

                                                <label class="input-hero w-100">
                                                    <span class="input-name">
                                                        Company
                                                    </span>
                                                    <input type="text" v-model="invoice.company" class="form-control mb-3"
                                                        disabled></label>

                                                <label class="input-hero w-100">
                                                    <span class="input-name">
                                                        Client ID
                                                    </span>
                                                    <input type="number" v-model="invoice.clientId" class="form-control mb-3"
                                                        disabled></label>

                                                <label class="input-hero w-100">
                                                    <span class="input-name">
                                                        Test ID
                                                    </span>
                                                    <input type="text" v-model="tempInvoice.testId" class="form-control mb-3"
                                                        @input="validateUpdateTestId()">
                                                    <span v-if="updateTestError" class="text-danger">{{ updateTestError
                                                        }}</span><br></label>

                                                <label class="input-hero w-100">
                                                    <span class="input-name">
                                                        Region ID
                                                    </span>
                                                    <input type="text" v-model="tempInvoice.regionId"
                                                        class="form-control mb-3" @input="validateUpdateRegionId()">
                                                    <span v-if="updateRegionError" class="text-danger">{{
                                                        updateRegionError
                                                        }}</span><br></label>

                                                <label class="input-hero w-100">
                                                    <span class="input-name">
                                                        User ID
                                                    </span>
                                                    <input type="number" v-model="invoice.userId" class="form-control mb-3"
                                                        disabled></label>

                                                <div class="text-end mt-4">
                                                    <button class="btn me-2" :class="'secondary-button'"
                                                        data-bs-dismiss="modal" type="button"
                                                        @click="resetTempInvoice()">
                                                        Cancel
                                                    </button>
                                                    <button type="submit" class="btn btn-primary">
                                                        Update
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <!-- toggle button -->
                            <button class="toggle-button" :class="{ 'active': invoice.isActive }" data-bs-toggle="modal"
                                :data-bs-target="'#toggleStatusModal-' + invoice.id">
                                <span class="toggle-circle"></span>
                            </button>

                            <!-- Confirmation Modal -->
                            <div class="modal fade" :id="'toggleStatusModal-' + invoice.id" tabindex="-1"
                                aria-hidden="true">
                                <div class="modal-dialog modal-dialog-centered">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Confirm Update</h5>
                                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                                        </div>
                                        <div class="modal-body text-center">
                                            <p class="mb-0">Are you sure you want to update the record?</p>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn me-2" :class="'secondary-button'"
                                                data-bs-dismiss="modal">No</button>
                                            <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                                                @click="toggleStatus(invoice)">Yes</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="text-center" v-else>
            <img src="../../../public/dashboard-assets/images/M2/empty_record.png" style="width: 20%" class="my-5" />
            <h3 class="ms-5 mt-2">No Details Found</h3>
        </div>
    </div>
    <!-- pagination -->
        <div class=" my-2">
            <paginate v-model="currentPage" :page-count="Page_count" :margin-pages="1" :page-range="1"
            :click-handler="clickCallback" :prev-text="'< Prev'" :next-text="'Next >'" :container-class="'pagination'"
            :page-class="'page-item'" id="tour-invoice-registry-pagination">
            </paginate>
        </div>
    
</template>


<script>
import { mapActions } from "vuex";
import Paginate from "vuejs-paginate-next";
import "vue3-select/dist/vue3-select.css";
import Vue3Select from "vue3-select";

export default {
    name: "InvoiceRegistrySetting",
    components: {
        paginate: Paginate,
        Vue3Select,
    },
    data() {
        return {
            //roll
            invoices: [],
            // for pagination
            limit: 6,
            offset: 1,
            currentPage: 1,
            Page_count: 1,
            totalCount: 0,
            //for adding invoice
            selectedPartner: null,
            selectedClientId: null,
            invoiceUserObject: null,
            invoiceNumber: "",
            clientId: 1001,
            company: '',
            regionId: 0,
            testId: 0,
            Ids: [],
            selectedUserId: null,
            billingEmail: '',
            searchInput: '',
            partnerList: [],
            clientsList: [],
            showMobileSearch: false,
            //for validation
            invoiceError: '',
            regionError: '',
            testError: '',
            updateInvoiceError: '',
            updateRegionError: '',
            updateTestError: '',

            //for updating the invoice
            tempInvoice: {},

            //for active and inActive tabs
            activeTab: "active",
        }
    },
    async mounted() {

        this.fetchInvoices();
        this.PartnerList();

    },
    watch: {
        activeTab(newTab) {
            console.log("active tab",newTab)
            this.offset = 0; 
            this.currentPage = 1;
            this.fetchInvoices();
        }
    },
    methods: {
        ...mapActions(["GetInvoiceRegistries", "PutInvoiceRegistry", "PatchInvoiceStatus",
            "GetInvoiceUserById", "GetClientsByInvoiceType", "PostInvoiceRegistry", "ShowErrorMessage"]),
 
        searchInvoices() {
            this.fetchInvoices(true);
        },
        async fetchInvoices(isNewSearch = false) {
            
            if (isNewSearch) {
                this.offset = 1;
                this.currentPage = 1;
            }

            var model = {
                iLimit: this.limit,
                iOffSet: this.offset,
                isActive: this.activeTab === 'active' ? 1 : 0
            }
            
            if (this.searchInput.trim()) {
                model.iSearch = this.searchInput.trim();
            }

            try {
                var data = await this.GetInvoiceRegistries(model);
                this.invoices = data.object.data.registrySummary;
                this.Page_count = this.invoices
                    ? Math.ceil(data.object.data.filterCount / this.limit)
                    : 0;
            } catch (error) {
                console.log(error)
            }
        },
        async updateInvoice(invoice) {
            // Validate before submission
            this.validateUpdateInvoiceNo();
            this.validateUpdateRegionId();
            this.validateUpdateTestId();

            if (this.updateInvoiceError || this.updateRegionError || this.updateTestError) {
                return this.ShowErrorMessage("Field inputs were incorrect, Try Again!!");
            }
            try {
                Object.assign(invoice, this.tempInvoice);
                await this.PutInvoiceRegistry(invoice);
                var data = await this.fetchInvoices();
                this.invoices = data.object.data.registrySummary;
            } catch (error) {
                console.error("error updating invoice:", error);
            }
        },

        async toggleStatus(invoice) {
            try {

                const updatedStatus = invoice.isActive ? 0 : 1;
                invoice.isActive = !invoice.isActive;
                const requestData = {
                    id: invoice.id,
                    isActive: updatedStatus
                };
                await this.PatchInvoiceStatus(requestData);
                await this.fetchInvoices(); // To refresh after some change is made.

            } catch (error) {
                invoice.isActive = !invoice.isActive;
                console.log("Error toggling status:", error);
            }
        },
        opensearch() {
            document.querySelector(".Searching_input-box").classList.add("open");
        },
        async closesearch() {
            document.querySelector(".Searching_input-box").classList.remove("open");
            this.searchInput = '';
            var data = await this.fetchInvoices();
            this.invoices = data.object.data.registrySummary;
            this.Page_count = this.invoices
                ? Math.ceil(data.object.data.filterCount / this.limit)
                : 0;
        },
        clickCallback: function (pageNum) {
            this.offset = (pageNum - 1) * this.limit;
            this.fetchInvoices();
        },
        async updateClientId() {
            this.selectedUserId = null
            if (this.selectedPartner) {
                this.selectedClientId = this.selectedPartner.value;
                this.invoiceUserObject = await this.GetInvoiceUserById({
                    clientId: this.selectedClientId
                });
                this.Ids = this.invoiceUserObject.object.data.map(x => x.id)
                this.billingEmail = this.invoiceUserObject.object.data[0].billingEmail

            } else {
                this.selectedClientId = null;
                this.invoiceUserObject = null;
                this.billingEmail = null;
            }
        },
        async AddInvoice() {
            // Validate before submission
            this.validateInvoiceNo();
            this.validateRegionId();
            this.validateTestId();

            if (this.invoiceError || this.regionError || this.testError) {
                return this.ShowErrorMessage("Field inputs were incorrect, Try Again!!");
            }

            try {
                await this.PostInvoiceRegistry({
                    invoiceNumber: this.invoiceNumber,
                    clientId: this.selectedClientId,
                    userId: this.selectedUserId,
                    testId: this.testId,
                    regionId: this.regionId,
                    isActive: true,

                });
                var data = await this.fetchInvoices();
                this.invoices = data.object.data.registrySummary;
                this.clearInputs();
            } catch (error) {
                console.log(error)
            }
        },
        async PartnerList() {
            var clients = await this.GetClientsByInvoiceType();

            this.clientsList = clients?.object?.data?.map((i) => ({
                value: i.clientId,
                label: i.clientId + ' - ' + i.company,
            }));

        },
        clearInputs() {
            this.invoiceNumber = "",
                this.regionId = 0,
                this.testId = 0
            this.selectedPartner = null,
                this.selectedClientId = null,
                this.billingEmail = null,
                this.selectedUserId = null,
                this.tempInvoice = {}
        },
        toggleMobileSearch() {
            this.showMobileSearch = true;
        },
        closeMobileSearch() {
            this.showMobileSearch = false;
            this.searchInput = '';
            this.fetchInvoices();
        },
        validateInvoiceNo() {
            const pattern = /^[A-Z]{3}-[A-Z]{2}$/;
            this.invoiceError = pattern.test(this.invoiceNumber) ? '' : 'Format: ABC-DE (Only uppercase letters)';
        },
        validateRegionId() {
            const pattern = /^[0-9,]+$/;
            this.regionError = pattern.test(this.regionId) ? '' : 'Only numbers and commas are allowed';
        },
        validateTestId() {
            const pattern = /^[0-9]+$/;
            this.testError = pattern.test(this.testId) ? '' : 'Only numbers are allowed';
        },
        //Edit modal methods
        validateUpdateInvoiceNo() {
            const pattern = /^[A-Z]{3}-[A-Z]{2}$/;
            this.updateInvoiceError = pattern.test(this.tempInvoice.invoiceNumber) ? '' : 'Format: ABC-DE (Only uppercase letters)';
        },
        validateUpdateRegionId() {
            const pattern = /^[0-9,]+$/;
            this.updateRegionError = pattern.test(this.tempInvoice.regionId) ? '' : 'Only numbers and commas are allowed';
        },
        validateUpdateTestId() {
            const pattern = /^[0-9]+$/;
            this.updateTestError = pattern.test(this.tempInvoice.testId) ? '' : 'Only numbers are allowed';
        },
        loadTempInvoice(invoice) {
            this.tempInvoice = { ...invoice }; // Create a copy of the selected invoice
        },
        resetTempInvoice() {
            this.tempInvoice = {};
            this.updateRegionError = "";
            this.updateInvoiceError = "";
            this.updateTestError = "";
        }
    }
}
</script>

<style scoped>
/* .pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  overflow-x: auto; /* Allows scrolling if pagination overflows 
  white-space: nowrap;
  padding: 10px;
}

.pagination {
  display: flex;
  gap: 6px;
  flex-wrap: wrap; 
  justify-content: center;
  max-width: 100%;
}

button {
  padding: 8px 12px;
  border: none;
  background-color: #f1f1f1;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

button:hover {
  background-color: #ddd;
}

button.active {
  background-color: #ffcc00;
  color: black;
  font-weight: bold;
  border-radius: 50%;
  width: 32px;
  height: 32px;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}


@media screen and (max-width: 768px) {
  .pagination {
    justify-content: flex-start;
    overflow-x: auto; /* Horizontal scrolling for small screens 
    white-space: nowrap;
  }

  button {
    padding: 6px 10px;
    font-size: 12px;
  }
} */

.form-control {
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
    border: 1px solid #ccc;
    transition: box-shadow 0.2s ease-in-out;
}

.title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 16px;
}

.invoice-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

.invoice-table th,
.invoice-table td {
    border: 1px solid #ccc;
    padding: 10px;
    text-align: left;
}

.invoice-table th {
    background-color: #f2f2f2;
}

.invoice-table tr:nth-child(even) {
    background-color: #f9f9f9;
}

.action-buttons {
    display: flex;
    gap: 10px;
    align-items: center;
}


.toggle-button {
    width: 56px;
    height: 28px;
    background-color: #e5e7eb;
    border: none;
    border-radius: 14px;
    cursor: pointer;
    position: relative;
    transition: background-color 0.3s ease;
}

.toggle-button.active {
    background-color: #7b68ee;
}

.toggle-circle {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 24px;
    height: 24px;
    background-color: white;
    border-radius: 50%;
    transition: transform 0.3s ease;
    display: block;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.toggle-button.active .toggle-circle {
    transform: translateX(28px);
}

.toggle-button:disabled {
    background-color: #d1d5db;
    cursor: not-allowed;
}

.mobile-search-container {
    position: relative;
    flex-grow: 1;
    margin-right: 1rem;
}

.search-icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: #f5f5f5;
    border-radius: 8px;
}

.search-icon img {
    width: 20px;
    height: 20px;
}

.mobile-search-input {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background: white;
    padding: 8px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.mobile-search-input input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding-right: 35px;
}

.mobile-close-icon {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    cursor: pointer;
}

.mobile-add-btn {
    flex-shrink: 0;
}

@media (max-width: 767px) {
    .mobile-search-input {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        padding: 1rem;
        background: white;
        z-index: 1050;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }
}

.secondary-button {
    /* background-color: #FFFFFF; */
    font-size: medium !important;
    font-weight: 600;
    border-radius: 4px;
    color: #7b68ee;
    border: 2px solid #7b68ee !important;
    /* width: 100%; */
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    padding: 0.375rem 0.75rem;
    cursor: pointer;
}
</style>